export default __webpack_public_path__ + "static/media/gallery-wip-handle-cover_02.9d34e086.jpg";